<div *ngIf="getDeletedTrips; else specificTrip">
  <sd-portal-deleted-trips-audit
    [deletedScheduledAircraftTripSkeletonsLoading]="
      deletedScheduledAircraftTripSkeletonsLoading$ | async
    "
    [deletedScheduledAircraftTripSkeletonsLoaded]="
      deletedScheduledAircraftTripSkeletonsLoaded$ | async
    "
    [deletedScheduledAircraftTripSkeletons]="deletedScheduledAircraftTripSkeletons$ | async"
    [scheduledAircraftTripAuditLoading]="scheduledAircraftTripAuditLoading$ | async"
    [scheduledAircraftTripAuditLoaded]="scheduledAircraftTripAuditLoaded$ | async"
    [scheduledAircraftTripAudits]="scheduledAircraftTripAudits$ | async"
    [legAuditLoading]="flightAuditLoading$ | async"
    [legAuditLoaded]="flightAuditLoaded$ | async"
    [legAudits]="flightAudits$ | async"
    [flightPassengerAuditLoading]="flightPassengerAuditLoading$ | async"
    [flightPassengerAuditLoaded]="flightPassengerAuditLoaded$ | async"
    [flightPassengerAudits]="flightPassengerAudits$ | async"
    [flightPassengerCateringAuditLoading]="flightPassengerCateringAuditLoading$ | async"
    [flightPassengerCateringAuditLoaded]="flightPassengerCateringAuditLoaded$ | async"
    [flightPassengerCateringAudits]="flightPassengerCateringAudits$ | async"
    [flightPassengerHotelAuditLoading]="flightPassengerHotelAuditLoading$ | async"
    [flightPassengerHotelAuditLoaded]="flightPassengerHotelAuditLoaded$ | async"
    [flightPassengerHotelAudits]="flightPassengerHotelAudits$ | async"
    [flightPassengerTransportationAuditLoading]="flightPassengerTransportationAuditLoading$ | async"
    [flightPassengerTransportationAuditLoaded]="flightPassengerTransportationAuditLoaded$ | async"
    [flightPassengerTransportationAudits]="flightPassengerTransportationAudits$ | async"
    [flightCrewMemberAuditLoading]="flightCrewMemberAuditLoading$ | async"
    [flightCrewMemberAuditLoaded]="flightCrewMemberAuditLoaded$ | async"
    [flightCrewMemberAudits]="flightCrewMemberAudits$ | async"
    [flightCrewMemberCateringAuditLoading]="flightCrewMemberCateringAuditLoading$ | async"
    [flightCrewMemberCateringAuditLoaded]="flightCrewMemberCateringAuditLoaded$ | async"
    [flightCrewMemberCateringAudits]="flightCrewMemberCateringAudits$ | async"
    [flightCrewMemberHotelAuditLoading]="flightCrewMemberHotelAuditLoading$ | async"
    [flightCrewMemberHotelAuditLoaded]="flightCrewMemberHotelAuditLoaded$ | async"
    [flightCrewMemberHotelAudits]="flightCrewMemberHotelAudits$ | async"
    [flightCrewMemberTransportationAuditLoading]="
      flightCrewMemberTransportationAuditLoading$ | async
    "
    [flightCrewMemberTransportationAuditLoaded]="flightCrewMemberTransportationAuditLoaded$ | async"
    [flightCrewMemberTransportationAudits]="flightCrewMemberTransportationAudits$ | async"
    [flightBusinessPersonAuditLoading]="flightBusinessPersonAuditLoading$ | async"
    [flightBusinessPersonAuditLoaded]="flightBusinessPersonAuditLoaded$ | async"
    [flightBusinessPersonAudits]="flightBusinessPersonAudits$ | async"
    [scheduledEventAuditLoaded]="scheduledEventAuditLoaded$ | async"
    [scheduledEventAuditLoading]="scheduledEventAuditLoading$ | async"
    [scheduledEventAudits]="scheduledEventAudits$ | async"
    [legNoteAuditLoaded]="legNoteAuditLoaded$ | async"
    [legNoteAuditLoading]="legNoteAuditLoading$ | async"
    [legNoteAudits]="legNoteAudits$ | async"
    [flightFuelAuditLoading]="flightFuelAuditLoading$ | async"
    [flightFuelAuditLoaded]="flightFuelAuditLoaded$ | async"
    [flightFuelAudits]="flightFuelAudits$ | async"
    [deletedTripsLoading]="deletedTripsLoading$ | async"
    [deletedTripsLoaded]="deletedTripsLoaded$ | async"
    [deletedTrips]="deletedTrips$ | async"
    [tripLogsLoading]="tripLogsLoading$ | async"
    [tripLogsLoaded]="tripLogsLoaded$ | async"
    [tripLogs]="tripLogs$ | async"
    [tripLogsHasMore]="tripLogsHasMore$ | async"
    [deletedTripLegsLoading]="deletedTripLegsLoading$ | async"
    [deletedTripLegsLoaded]="deletedTripLegsLoaded$ | async"
    [deletedTripLegs]="deletedTripLegs$ | async"
    [deletedTripLegsHasMore]="deletedTripLegsHasMore$ | async"
    [legEventLogsLoading]="legEventLogsLoading$ | async"
    [legEventLogsLoaded]="legEventLogsLoaded$ | async"
    [legEventLogs]="legEventLogs$ | async"
    [legEventLogsHasMore]="legEventLogsHasMore$ | async"
    [legFlightLogsLoading]="legFlightLogsLoading$ | async"
    [legFlightLogsLoaded]="legFlightLogsLoaded$ | async"
    [legFlightLogs]="legFlightLogs$ | async"
    [legFlightLogsHasMore]="legFlightLogsHasMore$ | async"
    [legFuelLogsLoading]="legFuelLogsLoading$ | async"
    [legFuelLogsLoaded]="legFuelLogsLoaded$ | async"
    [legFuelLogs]="legFuelLogs$ | async"
    [legFuelLogsHasMore]="legFuelLogsHasMore$ | async"
    [flightCrewMembersLoading]="flightCrewMembersLoading$ | async"
    [flightCrewMembersLoaded]="flightCrewMembersLoaded$ | async"
    [flightCrewMembers]="flightCrewMembers$ | async"
    [flightCrewMembersHasMore]="flightCrewMembersHasMore$ | async"
    [crewLogsLoading]="crewLogsLoading$ | async"
    [crewLogsLoaded]="crewLogsLoaded$ | async"
    [crewLogs]="crewLogs$ | async"
    [crewLogsHasMore]="crewLogsHasMore$ | async"
    [crewCateringLogsLoading]="crewCateringLogsLoading$ | async"
    [crewCateringLogsLoaded]="crewCateringLogsLoaded$ | async"
    [crewCateringLogs]="crewCateringLogs$ | async"
    [crewCateringLogsHasMore]="crewCateringLogsHasMore$ | async"
    [crewHotelLogsLoading]="crewHotelLogsLoading$ | async"
    [crewHotelLogsLoaded]="crewHotelLogsLoaded$ | async"
    [crewHotelLogs]="crewHotelLogs$ | async"
    [crewHotelLogsHasMore]="crewHotelLogsHasMore$ | async"
    [crewTransportationLogsLoading]="crewTransportationLogsLoading$ | async"
    [crewTransportationLogsLoaded]="crewTransportationLogsLoaded$ | async"
    [crewTransportationLogs]="crewTransportationLogs$ | async"
    [crewTransportationLogsHasMore]="crewTransportationLogsHasMore$ | async"
    [flightPassengersLoading]="flightPassengersLoading$ | async"
    [flightPassengersLoaded]="flightPassengersLoaded$ | async"
    [flightPassengers]="flightPassengers$ | async"
    [flightPassengersHasMore]="flightPassengersHasMore$ | async"
    [passengerLogsLoading]="passengerLogsLoading$ | async"
    [passengerLogsLoaded]="passengerLogsLoaded$ | async"
    [passengerLogs]="passengerLogs$ | async"
    [passengerLogsHasMore]="passengerLogsHasMore$ | async"
    [passengerCateringLogsLoading]="passengerCateringLogsLoading$ | async"
    [passengerCateringLogsLoaded]="passengerCateringLogsLoaded$ | async"
    [passengerCateringLogs]="passengerCateringLogs$ | async"
    [passengerCateringLogsHasMore]="passengerCateringLogsHasMore$ | async"
    [passengerHotelLogsLoading]="passengerHotelLogsLoading$ | async"
    [passengerHotelLogsLoaded]="passengerHotelLogsLoaded$ | async"
    [passengerHotelLogs]="passengerHotelLogs$ | async"
    [passengerHotelLogsHasMore]="passengerHotelLogsHasMore$ | async"
    [passengerTransportationLogsLoading]="passengerTransportationLogsLoading$ | async"
    [passengerTransportationLogsLoaded]="passengerTransportationLogsLoaded$ | async"
    [passengerTransportationLogs]="passengerTransportationLogs$ | async"
    [passengerTransportationLogsHasMore]="passengerTransportationLogsHasMore$ | async"
    (skeletonsNextPage)="onSkeletonsNextPage()"
    (tripOpened)="onTripOpened($event)"
    (tripNextPage)="onTripNextPage($event)"
    (deletedTripOpened)="onDeletedTripOpened($event)"
    (deletedTripNextPage)="onDeletedTripNextPage($event)"
    (deletedTripLegsOpened)="onDeletedTripLegsOpened($event)"
    (deletedTripLegsNextPage)="onDeletedTripLegsNextPage($event)"
    (legEventLogsOpened)="onLegEventLogsOpened($event)"
    (legEventLogsNextPage)="onLegEventLogsNextPage($event)"
    (legFlightLogsOpened)="onLegFlightLogsOpened($event)"
    (legFlightLogsNextPage)="onLegFlightLogsNextPage($event)"
    (legFuelLogsOpened)="onLegFuelLogsOpened($event)"
    (legFuelLogsNextPage)="onLegFuelLogsNextPage($event)"
    (flightCrewMembersOpened)="onFlightCrewMembersOpened($event)"
    (flightCrewMembersNextPage)="onFlightCrewMembersNextPage($event)"
    (crewLogsOpened)="onCrewLogsOpened($event)"
    (crewLogsNextPage)="onCrewLogsNextPage($event)"
    (crewCateringLogsOpened)="onCrewCateringLogsOpened($event)"
    (crewCateringLogsNextPage)="onCrewCateringLogsNextPage($event)"
    (crewHotelLogsOpened)="onCrewHotelLogsOpened($event)"
    (crewHotelLogsNextPage)="onCrewHotelLogsNextPage($event)"
    (crewTransportationLogsOpened)="onCrewTransportationLogsOpened($event)"
    (crewTransportationLogsNextPage)="onCrewTransportationLogsNextPage($event)"
    (flightPassengersOpened)="onFlightPassengersOpened($event)"
    (flightPassengersNextPage)="onFlightPassengersNextPage($event)"
    (passengerLogsOpened)="onPassengerLogsOpened($event)"
    (passengerLogsNextPage)="onPassengerLogsNextPage($event)"
    (passengerCateringLogsOpened)="onPassengerCateringLogsOpened($event)"
    (passengerCateringLogsNextPage)="onPassengerCateringLogsNextPage($event)"
    (passengerHotelLogsOpened)="onPassengerHotelLogsOpened($event)"
    (passengerHotelLogsNextPage)="onPassengerHotelLogsNextPage($event)"
    (passengerTransportationLogsOpened)="onPassengerTransportationLogsOpened($event)"
    (passengerTransportationLogsNextPage)="onPassengerTransportationLogsNextPage($event)"
    (legOpened)="onLegOpened($event)"
    (legNextPage)="onLegNextPage($event)"
    (passengerOpened)="onPassengerOpened($event)"
    (passengerNextPage)="onPassengerNextPage($event)"
    (passengerCateringOpened)="onPassengerCateringOpened($event)"
    (passengerCateringNextPage)="onPassengerCateringNextPage($event)"
    (passengerHotelOpened)="onPassengerHotelOpened($event)"
    (passengerHotelNextPage)="onPassengerHotelNextPage($event)"
    (passengerTransportationOpened)="onPassengerTransportationOpened($event)"
    (passengerTransportationNextPage)="onPassengerTransportationNextPage($event)"
    (crewMemberOpened)="onCrewMemberOpened($event)"
    (crewMemberNextPage)="onCrewMemberNextPage($event)"
    (crewMemberCateringOpened)="onCrewMemberCateringOpened($event)"
    (crewMemberCateringNextPage)="onCrewMemberCateringNextPage($event)"
    (crewMemberHotelOpened)="onCrewMemberHotelOpened($event)"
    (crewMemberHotelNextPage)="onCrewMemberHotelNextPage($event)"
    (crewMemberTransportationOpened)="onCrewMemberTransportationOpened($event)"
    (crewMemberTransportationNextPage)="onCrewMemberTransportationNextPage($event)"
    (businessPersonOpened)="onBusinessPersonOpened($event)"
    (businessPersonNextPage)="onBusinessPersonNextPage($event)"
    (scheduledEventOpened)="onScheduledEventOpened($event)"
    (scheduledEventNextPage)="onScheduledEventNextPage($event)"
    (legNoteOpened)="onLegNoteOpened($event)"
    (legNoteNextPage)="onLegNoteNextPage($event)"
    (flightFuelOpened)="onFlightFuelOpened($event)"
    (flightFuelNextPage)="onFlightFuelNextPage($event)"
  ></sd-portal-deleted-trips-audit>
</div>
<ng-template #specificTrip>
  <sd-portal-scheduled-trip-audit
    [tripId]="tripId$ | async"
    [scheduledAircraftTripSkeleton]="scheduledAircraftTripSkeleton$ | async"
    [scheduledAircraftTripSkeletonLoading]="scheduledAircraftTripSkeletonLoading$ | async"
    [scheduledAircraftTripSkeletonLoaded]="scheduledAircraftTripSkeletonLoaded$ | async"
    [tripAuditLoading]="scheduledAircraftTripAuditLoading$ | async"
    [tripAuditLoaded]="scheduledAircraftTripAuditLoaded$ | async"
    [tripAudits]="scheduledAircraftTripAudits$ | async"
    [tripLogsLoading]="tripLogsLoading$ | async"
    [tripLogsLoaded]="tripLogsLoaded$ | async"
    [tripLogs]="tripLogs$ | async"
    [tripLogsHasMore]="tripLogsHasMore$ | async"
    [tripLegsLoading]="tripLegsLoading$ | async"
    [tripLegsLoaded]="tripLegsLoaded$ | async"
    [tripLegs]="tripLegs$ | async"
    [tripLegsHasMore]="tripLegsHasMore$ | async"
    [legAuditLoading]="flightAuditLoading$ | async"
    [legAuditLoaded]="flightAuditLoaded$ | async"
    [legAudits]="flightAudits$ | async"
    [passengerAuditLoaded]="flightPassengerAuditLoaded$ | async"
    [passengerAuditLoading]="flightPassengerAuditLoading$ | async"
    [passengerAudits]="flightPassengerAudits$ | async"
    [passengerCateringAuditLoaded]="flightPassengerCateringAuditLoaded$ | async"
    [passengerCateringAuditLoading]="flightPassengerCateringAuditLoading$ | async"
    [passengerCateringAudits]="flightPassengerCateringAudits$ | async"
    [passengerHotelAuditLoaded]="flightPassengerHotelAuditLoaded$ | async"
    [passengerHotelAuditLoading]="flightPassengerHotelAuditLoading$ | async"
    [passengerHotelAudits]="flightPassengerHotelAudits$ | async"
    [passengerTransportationAuditLoaded]="flightPassengerTransportationAuditLoaded$ | async"
    [passengerTransportationAuditLoading]="flightPassengerTransportationAuditLoading$ | async"
    [passengerTransportationAudits]="flightPassengerTransportationAudits$ | async"
    [crewMemberAuditLoaded]="flightCrewMemberAuditLoaded$ | async"
    [crewMemberAuditLoading]="flightCrewMemberAuditLoading$ | async"
    [crewMemberAudits]="flightCrewMemberAudits$ | async"
    [crewMemberCateringAuditLoaded]="flightCrewMemberCateringAuditLoaded$ | async"
    [crewMemberCateringAuditLoading]="flightCrewMemberCateringAuditLoading$ | async"
    [crewMemberCateringAudits]="flightCrewMemberCateringAudits$ | async"
    [crewMemberHotelAuditLoaded]="flightCrewMemberHotelAuditLoaded$ | async"
    [crewMemberHotelAuditLoading]="flightCrewMemberHotelAuditLoading$ | async"
    [crewMemberHotelAudits]="flightCrewMemberHotelAudits$ | async"
    [crewMemberTransportationAuditLoaded]="flightCrewMemberTransportationAuditLoaded$ | async"
    [crewMemberTransportationAuditLoading]="flightCrewMemberTransportationAuditLoading$ | async"
    [crewMemberTransportationAudits]="flightCrewMemberTransportationAudits$ | async"
    [businessPersonAuditLoaded]="flightBusinessPersonAuditLoaded$ | async"
    [businessPersonAuditLoading]="flightBusinessPersonAuditLoading$ | async"
    [businessPersonAudits]="flightBusinessPersonAudits$ | async"
    [scheduledEventAuditLoaded]="scheduledEventAuditLoaded$ | async"
    [scheduledEventAuditLoading]="scheduledEventAuditLoading$ | async"
    [scheduledEventAudits]="scheduledEventAudits$ | async"
    [legNoteAuditLoaded]="legNoteAuditLoaded$ | async"
    [legNoteAuditLoading]="legNoteAuditLoading$ | async"
    [legNoteAudits]="legNoteAudits$ | async"
    [flightFuelAuditLoaded]="flightFuelAuditLoaded$ | async"
    [flightFuelAuditLoading]="flightFuelAuditLoading$ | async"
    [flightFuelAudits]="flightFuelAudits$ | async"
    [flightCrewMembersLoading]="flightCrewMembersLoading$ | async"
    [flightCrewMembersLoaded]="flightCrewMembersLoaded$ | async"
    [flightCrewMembers]="flightCrewMembers$ | async"
    [flightCrewMembersHasMore]="flightCrewMembersHasMore$ | async"
    [crewLogsLoading]="crewLogsLoading$ | async"
    [crewLogsLoaded]="crewLogsLoaded$ | async"
    [crewLogs]="crewLogs$ | async"
    [crewLogsHasMore]="crewLogsHasMore$ | async"
    [crewCateringLogsLoading]="crewCateringLogsLoading$ | async"
    [crewCateringLogsLoaded]="crewCateringLogsLoaded$ | async"
    [crewCateringLogs]="crewCateringLogs$ | async"
    [crewCateringLogsHasMore]="crewCateringLogsHasMore$ | async"
    [crewHotelLogsLoading]="crewHotelLogsLoading$ | async"
    [crewHotelLogsLoaded]="crewHotelLogsLoaded$ | async"
    [crewHotelLogs]="crewHotelLogs$ | async"
    [crewHotelLogsHasMore]="crewHotelLogsHasMore$ | async"
    [crewTransportationLogsLoading]="crewTransportationLogsLoading$ | async"
    [crewTransportationLogsLoaded]="crewTransportationLogsLoaded$ | async"
    [crewTransportationLogs]="crewTransportationLogs$ | async"
    [crewTransportationLogsHasMore]="crewTransportationLogsHasMore$ | async"
    [flightPassengersLoading]="flightPassengersLoading$ | async"
    [flightPassengersLoaded]="flightPassengersLoaded$ | async"
    [flightPassengers]="flightPassengers$ | async"
    [flightPassengersHasMore]="flightPassengersHasMore$ | async"
    [passengerLogsLoading]="passengerLogsLoading$ | async"
    [passengerLogsLoaded]="passengerLogsLoaded$ | async"
    [passengerLogs]="passengerLogs$ | async"
    [passengerLogsHasMore]="passengerLogsHasMore$ | async"
    [passengerCateringLogsLoading]="passengerCateringLogsLoading$ | async"
    [passengerCateringLogsLoaded]="passengerCateringLogsLoaded$ | async"
    [passengerCateringLogs]="passengerCateringLogs$ | async"
    [passengerCateringLogsHasMore]="passengerCateringLogsHasMore$ | async"
    [passengerHotelLogsLoading]="passengerHotelLogsLoading$ | async"
    [passengerHotelLogsLoaded]="passengerHotelLogsLoaded$ | async"
    [passengerHotelLogs]="passengerHotelLogs$ | async"
    [passengerHotelLogsHasMore]="passengerHotelLogsHasMore$ | async"
    [passengerTransportationLogsLoading]="passengerTransportationLogsLoading$ | async"
    [passengerTransportationLogsLoaded]="passengerTransportationLogsLoaded$ | async"
    [passengerTransportationLogs]="passengerTransportationLogs$ | async"
    [passengerTransportationLogsHasMore]="passengerTransportationLogsHasMore$ | async"
    [legFuelLogsLoading]="legFuelLogsLoading$ | async"
    [legFuelLogsLoaded]="legFuelLogsLoaded$ | async"
    [legFuelLogs]="legFuelLogs$ | async"
    [legFuelLogsHasMore]="legFuelLogsHasMore$ | async"
    [flightSchedulersLoading]="flightSchedulersLoading$ | async"
    [flightSchedulersLoaded]="flightSchedulersLoaded$ | async"
    [flightSchedulers]="flightSchedulers$ | async"
    [flightSchedulersHasMore]="flightSchedulersHasMore$ | async"
    [schedulerLogsLoading]="schedulerLogsLoading$ | async"
    [schedulerLogsLoaded]="schedulerLogsLoaded$ | async"
    [schedulerLogs]="schedulerLogs$ | async"
    [schedulerLogsHasMore]="schedulerLogsHasMore$ | async"
    [legEventLogsLoading]="legEventLogsLoading$ | async"
    [legEventLogsLoaded]="legEventLogsLoaded$ | async"
    [legEventLogs]="legEventLogs$ | async"
    [legEventLogsHasMore]="legEventLogsHasMore$ | async"
    [legFlightLogsLoading]="legFlightLogsLoading$ | async"
    [legFlightLogsLoaded]="legFlightLogsLoaded$ | async"
    [legFlightLogs]="legFlightLogs$ | async"
    [legFlightLogsHasMore]="legFlightLogsHasMore$ | async"
    (onTripNextPage)="onTripNextPage($event)"
    (onTripLogsNextPage)="onScheduledTripLogsNextPage($event)"
    (onTripLegsNextPage)="onScheduledTripLegsNextPage($event)"
    (onLegOpened)="onLegOpened($event)"
    (onLegNextPage)="onLegNextPage($event)"
    (onPassengerOpened)="onPassengerOpened($event)"
    (onPassengerNextPage)="onPassengerNextPage($event)"
    (onPassengerCateringOpened)="onPassengerCateringOpened($event)"
    (onPassengerCateringNextPage)="onPassengerCateringNextPage($event)"
    (onPassengerHotelOpened)="onPassengerHotelOpened($event)"
    (onPassengerHotelNextPage)="onPassengerHotelNextPage($event)"
    (onPassengerTransportationOpened)="onPassengerTransportationOpened($event)"
    (onPassengerTransportationNextPage)="onPassengerTransportationNextPage($event)"
    (onCrewMemberOpened)="onCrewMemberOpened($event)"
    (onCrewMemberNextPage)="onCrewMemberNextPage($event)"
    (onCrewMemberCateringOpened)="onCrewMemberCateringOpened($event)"
    (onCrewMemberCateringNextPage)="onCrewMemberCateringNextPage($event)"
    (onCrewMemberHotelOpened)="onCrewMemberHotelOpened($event)"
    (onCrewMemberHotelNextPage)="onCrewMemberHotelNextPage($event)"
    (onCrewMemberTransportationOpened)="onCrewMemberTransportationOpened($event)"
    (onCrewMemberTransportationNextPage)="onCrewMemberTransportationNextPage($event)"
    (onBusinessPersonOpened)="onBusinessPersonOpened($event)"
    (onBusinessPersonNextPage)="onBusinessPersonNextPage($event)"
    (onScheduledEventOpened)="onScheduledEventOpened($event)"
    (onScheduledEventNextPage)="onScheduledEventNextPage($event)"
    (onLegNoteOpened)="onLegNoteOpened($event)"
    (onLegNoteNextPage)="onLegNoteNextPage($event)"
    (onFlightFuelOpened)="onFlightFuelOpened($event)"
    (onFlightFuelNextPage)="onFlightFuelNextPage($event)"
    (flightCrewMembersOpened)="onScheduledFlightCrewMembersOpened($event)"
    (flightCrewMembersNextPage)="onScheduledFlightCrewMembersNextPage($event)"
    (crewLogsOpened)="onCrewLogsOpened($event)"
    (crewLogsNextPage)="onCrewLogsNextPage($event)"
    (crewCateringLogsOpened)="onCrewCateringLogsOpened($event)"
    (crewCateringLogsNextPage)="onCrewCateringLogsNextPage($event)"
    (crewHotelLogsOpened)="onCrewHotelLogsOpened($event)"
    (crewHotelLogsNextPage)="onCrewHotelLogsNextPage($event)"
    (crewTransportationLogsOpened)="onCrewTransportationLogsOpened($event)"
    (crewTransportationLogsNextPage)="onCrewTransportationLogsNextPage($event)"
    (flightPassengersOpened)="onScheduledFlightPassengersOpened($event)"
    (flightPassengersNextPage)="onScheduledFlightPassengersNextPage($event)"
    (passengerLogsOpened)="onPassengerLogsOpened($event)"
    (passengerLogsNextPage)="onPassengerLogsNextPage($event)"
    (passengerCateringLogsOpened)="onPassengerCateringLogsOpened($event)"
    (passengerCateringLogsNextPage)="onPassengerCateringLogsNextPage($event)"
    (passengerHotelLogsOpened)="onPassengerHotelLogsOpened($event)"
    (passengerHotelLogsNextPage)="onPassengerHotelLogsNextPage($event)"
    (passengerTransportationLogsOpened)="onPassengerTransportationLogsOpened($event)"
    (passengerTransportationLogsNextPage)="onPassengerTransportationLogsNextPage($event)"
    (legFuelLogsOpened)="onLegFuelLogsOpened($event)"
    (legFuelLogsNextPage)="onLegFuelLogsNextPage($event)"
    (flightSchedulersOpened)="onScheduledFlightSchedulersOpened($event)"
    (flightSchedulersNextPage)="onScheduledFlightSchedulersNextPage($event)"
    (schedulerLogsOpened)="onSchedulerLogsOpened($event)"
    (schedulerLogsNextPage)="onSchedulerLogsNextPage($event)"
    (legEventLogsOpened)="onLegEventLogsOpened($event)"
    (legEventLogsNextPage)="onLegEventLogsNextPage($event)"
    (legFlightLogsOpened)="onLegFlightLogsOpened($event)"
    (legFlightLogsNextPage)="onLegFlightLogsNextPage($event)"
  ></sd-portal-scheduled-trip-audit>
</ng-template>
